import { Button, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutOrderPlanningActions extends Layout {
    buttonActions: Button;
    panelToolLeft: Panel;
    panelToolRight: Panel;
}
